import { useWallet } from '@solana/wallet-adapter-react'
import { PARTNER_WHITELIST } from 'utils/partners'

export function useIsPartnerWhitelisted() {
  const { publicKey } = useWallet()

  const isWhitelisted = PARTNER_WHITELIST.find(
    (wallet) => wallet === publicKey?.toBase58(),
  )

  return { isWhitelisted: !!isWhitelisted }
}
